import { render } from "./page-add-lazy-load.vue?vue&type=template&id=3d85965b&ts=true"
import script from "./page-add-lazy-load.vue?vue&type=script&lang=ts"
export * from "./page-add-lazy-load.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__